import EnergyA from '../../assets/EM-A.svg';
import EnergyB from '../../assets/EM-B.svg';
import EnergyC from '../../assets/EM-C.svg';
import EnergyD from '../../assets/EM-D.svg';
import EnergyE from '../../assets/EM-E.svg';
import EnergyF from '../../assets/EM-F.svg';
import EnergyG from '../../assets/EM-G.svg';

export type TEnergyBadge = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G';

export const resolveEnergyBadge = (badge: TEnergyBadge) => {
  switch (badge) {
    case 'A':
      return EnergyA;
    case 'B':
      return EnergyB;
    case 'C':
      return EnergyC;
    case 'D':
      return EnergyD;
    case 'E':
      return EnergyE;
    case 'F':
      return EnergyF;
    case 'G':
      return EnergyG;
  }
};
